import React from 'react';
import { render } from 'react-dom';

import Moment from 'react-moment';
import moment from 'moment';
import 'moment-timezone';

import * as Sentry from '@sentry/browser';
import { Cookies } from './utils/utils';
import configureStore from './store/configureStore';
import { history } from './routes/AppRouter';

import { startSetAppSettings } from './actions/app';
import { logout, startSetProfile, initialization } from './actions/webmaster';

import Loader from './components/Loader/Loader';
import Exit from './components/Exit/Exit';

import '../styles/styles.scss';

import { defaultLocale } from './config';

import App from './components/App/App';
import { applyThemeClass, getStoredTheme } from './utils/themeStorage';

const store = configureStore();
const webmasterStore = store.getState().webmaster;

const {
  profile: { language },
} = webmasterStore;

Moment.globalMoment = moment;
Moment.globalLocale = language || defaultLocale;

let hasRendered = false;

const renderApp = ({ timezone }) => {
  if (!hasRendered) {
    render(
      <App timezone={timezone} store={store} defaultLocale={defaultLocale} />,
      document.getElementById('app'),
    );
    hasRendered = true;

    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }
};

// Theme must be on <html> before the boot Loader — App mounts later.
const storedTheme = getStoredTheme();
if (storedTheme) {
  applyThemeClass(storedTheme);
}

render(<Loader />, document.getElementById('app'));

const ensureIntlSupport = () => {
  if (window.Intl) return Promise.resolve();
  return new Promise((resolve) => {
    resolve(require('intl'));
  }).then(() =>
    Promise.all([require(`intl/locale-data/jsonp/ru.js`), require(`intl/locale-data/jsonp/en.js`)]),
  );
};

ensureIntlSupport().then(() => {
  store.dispatch(startSetAppSettings());
  store.dispatch(startSetProfile()).then(() => {
    const { webmaster = {} } = store.getState();

    if (webmaster.isAuthenticated) {
      if (PRODUCTION) {
        Sentry.init({
          dsn: 'https://bd8c60ef1436409fb1b12cabc2e7657a@sentry.offerrum.com/4',
          beforeSend(event) {
            return event;
          },
        });
        Sentry.configureScope((scope) => {
          if (webmaster.profile) {
            scope.setUser({
              login: webmaster.profile.login,
              email: webmaster.profile.email,
            });
            scope.setExtra('webmaster', webmaster.profile);
          }
        });
      }

      store.dispatch(initialization());

      if (!webmaster.profile.email.trim().length) {
        history.push('/profile/edit');
      } else {
        history.location.pathname === '/' && history.push('/dashboard');
      }

      const settings = {
        timezone: webmaster.profile.timezone,
      };

      renderApp(settings);
    } else {
      console.log('logout');
      // Если был переход по ссылке my.offerrum/... -> сохраняем в куках -> в момент signin вытаскиваем и отправялем на бек
      const href = window.location.href;

      Cookies.set('redirect_url', href, {
        domain: '.tutorplace.ru',
        path: '/',
      });

      store.dispatch(logout());

      render(<Exit />, document.getElementById('app'));
    }
  });
});

export default {
  store,
};

if (module.hot) {
  module.hot.accept();
}
